function LiveTV({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width="${dimensions || 22}" height="${dimensions || 20}" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 8V16L15 12L8 8ZM20 4H12.42L15.71 0.71L15 0L11 4H10.97L6.97 0L6.28 0.71L9.56 4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H2V6H20V18Z" fill="${col}"/>
    </svg>

  `;

  return baseXml;
}

export default LiveTV;
